<template>
  <FiltersItem>
    <template #title>
      {{ $l('showresult.filter.timeTitle') }}
    </template>
    <template #content>
      <!-- Max length per leg -->
      <FiltersItemTimeLength v-if="resultQueryStore.state?.response?.uniqueMaxTraveltimePerTrip?.length > 1" />

      <!-- Trip duration -->
      <FiltersItemContent>
        <template #content>
          <div class="filtersTimetable">
            <template
              v-for="(searchParamsTripData, journeyIndex) in resultQueryStore.state.response.uniqueTimes"
              :key="journeyIndex"
            >
              <!-- Title -->
              <h5 class="filtersTimetable__title">
                <span class="icon icon-circle-plane-up" /> <span>{{ getLegInfo(journeyIndex) }}</span>
              </h5>
              <!-- Departure slider -->
              <FiltersItemTimeSlider
                v-if="resultQueryStore.state.response.uniqueTimes[journeyIndex]?.departures"
                :title="$l('showresult.filter.departureText')"
                type="departures"
                :trip-index="journeyIndex"
                :unique-times="resultQueryStore.state.response.uniqueTimes?.[journeyIndex]?.departures"
                property-key="departureTime"
              />
              <br v-if="resultQueryStore.state.response.uniqueTimes[journeyIndex]?.arrivals">
              <!-- Arrival slider -->
              <FiltersItemTimeSlider
                v-if="resultQueryStore.state.response.uniqueTimes[journeyIndex]?.arrivals"
                :title="$l('showresult.filter.arrivalText')"
                type="arrivals"
                :unique-times="resultQueryStore.state.response.uniqueTimes[journeyIndex]?.arrivals"
                :trip-index="journeyIndex"
                property-key="arrivalTime"
              />
              <br>
              <br v-if="journeyIndex !== resultQueryStore.state.response.uniqueTimes.length - 1">
            </template>
          </div>
        </template>
      </FiltersItemContent>
    </template>
    <template #summary>
      <FiltersItemSummary :items="summaryItems" />
    </template>
  </FiltersItem>
</template>

<script setup>
import { l, lreplace } from '@utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();

const summaryItems = computed(() => {
	const summary = [];

	if (filtersStore.state.traveltime) {
		summary.push(lreplace('showresult.filter.summary.maxTraveltimePerTrip', { time: filtersStore.state.traveltime }));
	}

	if (Object.keys(filtersStore.state.departureTime).length) {
		summary.push(l('showresult.filter.summary.customDepartureTimes'));
	}

	if (Object.keys(filtersStore.state.arrivalTime).length) {
		summary.push(l('showresult.filter.summary.customArrivalTime'));
	}

	return summary;
});


function getLegInfo (index, side) {
	const tripType = js_params?.returntrip || 1;
	const trip = js_params.showresultSearchParams[(tripType === 2) ? index : 0];

	const isInbound = tripType === 1 && index === 1;
	const tripFrom = (isInbound) ? trip.to : trip.from;
	const tripTo = (isInbound) ? trip.from : trip.to;

	return (!tripFrom || !tripTo) ? '' : `${tripFrom} ${l('global.simplePhrases.To', 'to')} ${tripTo}`;
}
</script>
<style lang="scss">
.filtersTimetable__title {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.3rem;
  font-weight: 900;
  color: $main-font-color;

  @include breakpoint_up(xxs) {
    font-size: 1.5rem;
  }

  & > span:first-child {
    font-weight: 900;
    font-size: 1.4rem;
    position: relative;
    top: 1px;

    @include breakpoint_up(xxs) {
      font-size: 1.7rem;
    }
  }
}
</style>
